(ns app.domain.booking.model
  (:require #?(:cljs [core.front.date-util :as date-util])
            [app.domain.group.model :as group-model]
            [app.domain.util :as du]
            [core.db.child-entity :as child]
            [core.db.entity.util :as eu])
  #?(:clj (:import java.util.Date
                   org.apache.commons.lang3.time.DateUtils)))

(def is-booking? (partial eu/is-type? :entity.type/booking))

(def changeable-booking-states
  #{:booking.state/dispatched
    :booking.state/to-dispatch})

(defn get-visit
  "Given a booking, return the associated visit"
  [booking]
  ;; only one visit per booking -> always pick first
  (-> booking :inspection.visit/_booking first))


(defn get-booking-phase [booking-or-visit]
  (-> booking-or-visit
      :entity/parent ; inspection
      :entity/parent ; execution or application
      ))

(defn get-workspace [booking-or-visit]
  (-> booking-or-visit
      ;; inspection
      :entity/parent
      ;; execution or application
      :entity/parent
      ;; workspace
      :entity/parent))

(defmethod group-model/get-authority-group :entity.type/booking
  [booking]
  (-> booking get-workspace :domain/authority-group))

(defn get-dispatch-window [booking]
  (or (:group/dispatch-window booking) ; Cache for dashboard so we don't need the whole hierarchy
      (-> booking
          get-workspace
          :domain/authority-group
          :group/dispatch-window)
      (* 180))) ; default is six months (two weeks was too short)

(defn booking-in-dispatch-window?
  "Bookings in the far future are not considered relevant for dispatching (default six months)"
  [{:booking/keys [requested-start-time] :as booking}]
  (let [window-date #?(:clj  (DateUtils/addDays (Date.) (get-dispatch-window booking))
                       :cljs (date-util/date-add (get-dispatch-window booking)))
        is-before?  #?(:clj  #(.before ^Date %1 %2)
                       :cljs <)]
    (is-before? requested-start-time window-date)))

(def cancelled? (du/in-state-fn :booking.state/cancelled))
(defn to-dispatch? [booking]
  (and (du/in-state? :booking.state/to-dispatch booking)
       (booking-in-dispatch-window? booking)))

(def default-freeze-time [6 00])

(def max-freeze-time-days 100) ;; CA-3543071-B seems to be using 90 days in production

(defn workspace-db-id-vector
  "Changes in booking state cause an :es-ws-update outject since the :next-inspection-date value
  in Elasticsearch is dependent on the next upcoming dispatched booking.
  Returns nil on missing booking for assoc-if"
  [booking]
  (some-> booking get-workspace :db/id vector))

(defn get-upcoming-start-time
  "Best approximation of when this booking/request will be fulfilled;
  does not consider already fulfilled or cancelled bookings"
  [booking]
  (case (:domain/state booking)
    :booking.state/to-dispatch (:booking/requested-start-time booking)
    :booking.state/dispatched  (:booking/actual-start-time booking)
    nil))

(def ^{:arglists '([group])} group-availabilities
  (child/child-entities-of-type-fn :entity.type/availability))

(defn group-availability [group]
  (->> (group-availabilities group)
       (sort-by :entity/valid-from)
       last))

(defn time-slots-from-availability [availability]
  (->> availability
       ((juxt :availability/time-slots :availability/customer-time-slots))
       (apply concat)))

(defn workdays-from-availability [availability]
  (->> (time-slots-from-availability availability)
       (map :time-slot/weekday)
       set))

(def workdays-for-group
  (comp workdays-from-availability
        group-availability))

(defn distinct-time-slot-times
  "Return the distinct time slot times for `time-slot-attr` as maps, ignoring the weekday of the time slots.
  `time-slot-attr` must be :availability/time-slots or :availability/customer-time-slots"
  [time-slot-attr availability]
  (->> availability
       time-slot-attr
       (map #(select-keys % [:time-slot/start-hour
                             :time-slot/start-minute
                             :time-slot/end-hour
                             :time-slot/end-minute]))
       distinct
       (sort-by (juxt :time-slot/start-hour :time-slot/start-minute))))

(def ^{:arglists '([time-slot])} availability-from-time-slot
  (some-fn :availability/_time-slots :availability/_customer-time-slots))

(defn required-qualifications [booking]
  (-> booking
      :entity/parent
      :inspection/inspector-qualifications))
